module.exports = {
	// This is required - used in the feedback form validation
    contact_email: 'info@lincsreservoir.co.uk',

    closed_message: "This consultation is closed and is no longer accepting feedback.",
    review_url: "/consultation/have-your-say/feedback-form/review/",
    success_url: "/consultation/have-your-say/feedback-form/success/",

	// This value needs to match the slug of the contact section. Determines which fields to show
	contact_slug: "about-you",

	sections: [
		{
            name: "About you",
            slug: "about-you",
			icon: "",
			colour: "green-200", // This needs to match a colour set in _variables.scss

			description: `By providing us with the below information, you will help us better understand the feedback we receive. All information will be processed in accordance with our <a href="https://www.anglianwater.co.uk/corporate/about-us/legal/privacy-notice/" target="_blank" rel="noreferrer">privacy policy</a>.`,

            questions: [
                {
                    label: "Title",
                    name: "title",
                    required: false,
                    type: "text",
                    placeholder: "Enter your title"
				},
				{
                    label: "First name",
                    name: "first_name",
                    required: true,
                    type: "text",
                    placeholder: "Enter your first name"
				},
				{
                    label: "Last name",
                    name: "last_name",
                    required: true,
                    type: "text",
                    placeholder: "Enter your last name"
                },
				{
					label: "Address",
					name: "address",
					required: true,
					type: "text",
					placeholder: "Enter your address"
				},
                {
					label: "Postcode",
                    name: "postcode",
                    required: true,
                    type: "text",
                    placeholder: "Enter your postcode",
                },
                {
					label: "Email",
                    name: "email",
                    required: true,
                    type: "email",
                    placeholder: "Enter your email",
                },
                {
					label: "If you do not already, would you like to receive email updates about the project?",
                    name: "progress",
					type: "radio",
					required: true,
					multiple: false, // Not required, for visual use only

                    options: [
						{
							label: "Yes",
                            value: "yes"
                        },
                        {
							label: "No",
                            value: "no"
                        }
                    ],
                },
				{
					label: "Are you submitting a formal response on behalf of an organisation?",
					name: "organisation",
					required: false,
					type: "radio",
					multiple: false, // Not required, for visual use only

					options: [
						{
							label: "Yes",
							value: "yes"
						},
						{
							label: "No",
							value: "no"
						}
					],
				},
				{
					label: "If yes, which organisation:",
                    name: "organisation_confirm",
                    required: false,
                    type: "text",
                    placeholder: "Enter organisation",
				},
				{
					label: "Do you own, lease, occupy or have an interest in land within the indicative project boundary?",
					name: "land_interest",
					required: false,
					type: "radio",
					multiple: false, // Not required, for visual use only

					options: [
						{
							label: "Yes",
							value: "yes"
						},
						{
							label: "No",
							value: "no"
						}
					],
				},
				{
					label: "If yes, have you been contacted by us about your land interest?",
					name: "contacted_land_interest",
					required: false,
					type: "radio",
					multiple: false, // Not required, for visual use only

					options: [
						{
							label: "Yes",
							value: "yes"
						},
						{
							label: "No",
							value: "no"
						}
					],
				},
				{
					label: "If you have not been contacted by us, please provide the details of this land, including address, if different to the above so we can contact you.",
                    name: "land_interest_other",
                    required: false,
                    type: "text",
                    placeholder: "Enter details",
				},
				{
					label: "Which of the following best describes you in relation to the proposed location of the reservoir? (Please tick all that apply):",
					name: "relation",
					required: false,
					type: "checkbox",
					multiple: true, // Not required, for visual use only

					options: [
						{
							label: "I'm a local resident",
							value: "Local resident"
						},
						{
							label: "I'm a member of an interest group (please specify below)",
							value: "Interest group"
						},
						{
							label: "I'm employed locally",
							value: "Locally employed"
						},
						{
							label: "I'm a local business owner",
							value: "Local business owner"
						},
						{
							label: "I commute to the area",
							value: "Commuter to area"
						},
						{
							label: "I'm a future resident",
							value: "Future resident"
						},
						{
							label: "I'm a visitor to the area",
							value: "Visitor"
						},
						{
							label: "I'm a student/studying",
							value: "Student"
						},
						{
							label: "I'm an elected representative (please specify below)",
							value: "Elected representative"
						},
						{
							label: "Other (please specify below)",
							value: "Other"
						},
					],
				},
				{
					label: "Please specify details:",
                    name: "relation_other",
                    required: false,
                    type: "text",
                    placeholder: "Enter details",
				},
            ]
        },
        {
            name: "Emerging design for the main reservoir site",
            slug: "emerging-design",
			icon: "",
			colour: "green-200", // This needs to match a colour set in _variables.scss

			description: `<p>Our proposals include an emerging design for the main reservoir site. This includes the overall design approach to the main reservoir site together with opportunities for recreation, nature, access points, wetlands, embankment design and other features. It also includes visualisations of potential locations for renewable energy infrastructure, as part of our early stage plans for how we manage carbon emissions.</p><p>The emerging design is described in our <a target="_blank" href="/assets/images/downloads/Reservoir-brochure-2024(SINGLES).pdf">main site design brochure</a> and <a target="_blank" href="/assets/images/downloads/Main-site-design-report-phase-two-consultation-2024.pdf">main site design report</a>.</p>`,

			sub_sections: [
				{
					name: "The emerging design for the main reservoir site", // Can be left empty

					groups: [
						{
							name: "", // Can be left empty

							description: "", // Can be left empty

							questions: [
								{
									label: "Do you have any comments on the site-specific design vision and principles?",
									number: "1",
									name: "1-question",
									type: "text",
								},
								{
									label: "Do you have any overall comments on the emerging design for the main reservoir site?",
									number: "2",
									name: "2-question",
									type: "text",
								},
								{
									label: "Do you have any comments on the initial opportunities for potential recreational areas?",
									number: "3",
									name: "3-question",
									type: "text",
								},
								{
									label: "Do you have any comments on the initial opportunities for potential environmental areas and wildlife habitats?",
									number: "4",
									name: "4-question",
									type: "text",
								},
								{
									label: "Do you have any comments on the initial opportunities for footpaths, cycleways and bridleways within the main reservoir site?",
									number: "5",
									name: "5-question",
									type: "text",
								},
								{
									label: "Do you have any comments on initial opportunities for potential access arrangements from the surrounding area to the main reservoir site?",
									number: "6",
									name: "6-question",
									type: "text",
								},
								{
									label: "Do you have any comments on the proposed indicative route for the diversion of the road link between Helpringham and Scredington, as visualised in the emerging design?",
									number: "7",
									name: "7-question",
									type: "text",
								},
								{
									label: "Do you have any comments on our early stage plans to include renewable energy generation at the main reservoir site?",
									number: "8",
									name: "8-question",
									type: "text",
								},
								{
									label: "Do you have any additional feedback about the emerging design for the main reservoir site that you have not included above?",
									number: "9",
									name: "9-question",
									type: "text",
								},
							]
						}
					]
				},
				{
					name: "Areas of land for environmental mitigation, construction and wider uses",

					groups: [
						{
							name: "", // Can be left empty

							description: `<p>Our indicative project boundary also includes preliminary areas of land near to the main reservoir site which we could need for environmental mitigation and enhancement, construction, and other works
							related to the main reservoir site. Our proposals for these areas are at an early stage and subject to further assessment and consultation. Whether that land is needed on a permanent or temporary basis is still to be
							assessed and confirmed. These areas of land are shown in our <a target="_blank" href="/assets/images/downloads/Reservoir-brochure-2024(SINGLES).pdf">main site design brochure</a>.</p>`,

							questions: [
								{
									label: "Do you have any comments on the identified areas or is there any information you think we should know about these areas?",
									number: "10",
									name: "10-question",
									type: "text",
								},
							]
						}
					]
				},
			],
		},
		{
			name: "Proposals for water sources infrastructure",
			slug: "water-sources-infrastructure",
			icon: "",
			colour: "blue-500", // This needs to match a colour set in _variables.scss

			description: `<p>Our proposals include the associated water infrastructure we need to draw water from the sources we have identified and transfer it to the reservoir. The exact combination of water sources infrastructure we propose
			to use will be confirmed at the next phase of consultation.</p><p>To identify the preferred options listed below we undertook an options appraisal. You can read more about this and why have we have selected the preferred options in our <a target="_blank" href="/assets/images/downloads/Associated-Infrastructure-brochure-2024(SINGLES).pdf">associated water infrastructure brochure</a> and <a target="_blank" href="/assets/images/downloads/Options-appraisal-report-Lincs Reservoir-phase-two-consultation-2024.pdf">options appraisal report</a>.</p>`,

			sub_sections: [
				{
					name: "Drawing water from sources and transferring it to the reservoir",

					groups: [
						{
							name: "South Forty Foot Drain to reservoir: open channel transfer directly to the reservoir via the upgraded Helpringham South Beck",

							description: "", // Can be left empty

							questions: [
								{
									label: "Do you have any comments on our proposed plans for the work needed to transfer water from this source to the reservoir?",
									number: "11",
									name: "11-question",
									type: "text",
								},
							]
						},
						{
							name: "River Trent: abstraction infrastructure (pumping station and, if needed, treatment facilities) and transfer to the reservoir via the Fossdyke and the River Witham",

							description: "", // Can be left empty

							questions: [
								{
									label: "Do you have any comments on our proposed plans for the infrastructure we need to draw water from this source and transfer it to the reservoir?",
									number: "12",
									name: "12-question",
									type: "text",
								},
							]
						},
						{
							name: "River Witham: abstraction infrastructure (pumping station and, if needed, treatment facilities) and transfer to the reservoir via the South Forty Foot Drain",

							description: "", // Can be left empty

							questions: [
								{
									label: "Do you have any comments on our proposed plans for the infrastructure we need to draw water from this source and transfer it to the reservoir?",
									number: "13",
									name: "13-question",
									type: "text",
								}
							]
						},
					]
				},
				{
					name: "Our proposals for water sources infrastructure more broadly",

					groups: [
						{
							name: "", // Can be left empty

							description: "", // Can be left empty

							questions: [
								{
									label: "Do you have any additional feedback on our proposals for drawing water from the sources we've identified and the related infrastructure that you have not included above?",
									number: "14",
									name: "14-question",
									type: "text",
								},
								{
									label: "Do you have any comments on the options appraisal report and the process we followed?",
									number: "15",
									name: "15-question",
									type: "text",
								}
							]
						}
					]
				},
			],
		},
		{
			name: "Proposals for water supply infrastructure",
			slug: "water-supply-infrastructure",
			icon: "",
			colour: "purple", // This needs to match a colour set in _variables.scss

			description: `<p>Our proposals include the associated water infrastructure we need to treat the water and supply it to homes and business through underground pipelines and service reservoirs.</p><p>To identify the preferred options listed below we undertook an options appraisal. You can read more about this and why have we have selected the preferred options in our <a target="_blank" href="/assets/images/downloads/Associated-Infrastructure-brochure-2024(SINGLES).pdf">associated water infrastructure brochure</a> and <a target="_blank" href="/assets/images/downloads/Options-appraisal-report-Lincs Reservoir-phase-two-consultation-2024.pdf">options appraisal report</a>.</p>`,

			sub_sections: [
				{
					name: "Water treatment works",

					groups: [
						{
							name: "", // Can be left empty

							description: `<p>Through our assessments, we've identified a preferred area of land within which we could build a water treatment works. This is south of the reservoir by the A52, between Swaton and Spanby. Your feedback and further assessments will help us identify a location for where the water treatment works could be located within this area.</p>`,

							questions: [
								{
									label: "Do you have any comments on the area of land we have identified for the water treatment works?",
									number: "16",
									name: "16-question",
									type: "text",
								},
							]
						},
					]
				},
				{
					name: "Supplying clean water to homes and businesses",

					groups: [
						{
							name: "Wilsthorpe connection point: proposed corridor for underground pipeline and proposed location for a service reservoir near Wilsthorpe", // Can be left empty

							description: "", // Can be left empty

							questions: [
								{
									label: "Do you have any comments on our proposed plans for the infrastructure we need to supply water to this connection point and the facilities we will require to connect to the existing supply network at this location?",
									number: "17",
									name: "17-question",
									type: "text",
								},
							]
						},
						{
							name: "Chesterton connection point: proposed corridor for underground pipeline and proposed location for a service reservoir near Chesterton.", // Can be left empty

							description: "", // Can be left empty

							questions: [
								{
									label: "Do you have any comments on our proposed plans for the infrastructure we need to supply water to this connection point and the facilities we will require to connect to the existing supply network at this location?",
									number: "18",
									name: "18-question",
									type: "text",
								},
							]
						},
					]
				},
				{
					name: "Our proposals for water supply infrastructure more broadly",

					groups: [
						{
							name: "", // Can be left empty

							description: "", // Can be left empty

							questions: [
								{
									label: " Do you have any additional feedback on our proposals for supplying water to the connection points we've identified and the related infrastructure that you have not included above?",
									number: "19",
									name: "19-question",
									type: "text",
								},
								{
									label: "Do you have any comments on the options appraisal report and the process we followed?",
									number: "20",
									name: "20-question",
									type: "text",
								}
							]
						}
					]
				}
			],
		},
		{
            name: "Other early-stage information",
            slug: "other-early-stage-info",
			icon: "",
			colour: "grey-600", // This needs to match a colour set in _variables.scss

			description: "", // Can be left empty

			sub_sections: [
				{
					name: "We have published a range of fact sheets on our early stage plans for managing wider considerations. Our work in these areas will progress as we develop our proposals and complete further assessments. More information will follow in our next consultation.", // Can be left empty

					groups: [
						{
							name: "", // Can be left empty

							description: `<p>In the meantime, we are open to comments on our emerging work in this area.</p>`, // Can be left empty

							questions: [
								{
									label: "Do you have any comments on our early approach to managing these wider considerations, as described in our fact sheets, that you would like us to consider as our proposals develop?",
									number: "21",
									name: "21-question",
									type: "text",
								},
							]
						},
					]
				},
			],
		},
		{
            name: "Your experience of our consultation",
            slug: "your-experience",
			icon: "",
			colour: "grey-600", // This needs to match a colour set in _variables.scss

			sub_sections: [
				{
					name: "", // Can be left empty

					groups: [
						{
							name: "", // Can be left empty

							questions: [
								{
									label: "How did you hear about the consultation? (Please select all that apply)",
									number: "22",
									name: "22-question",
									type: "checkbox",
									multiple: true, // Not required, for visual use only

									options: [
										{
											label: "Received information to my postal address",
											value: "postal-address"
										},
										{
											label: "Posters or information points in the area",
											value: "posters"
										},
										{
											label: "Online advertising",
											value: "online-advertising"
										},
										{
											label: "Online search",
											value: "online-search"
										},
										{
											label: "Social media",
											value: "social-media"
										},
										{
											label: "Notified by someone else",
											value: "someone-else"
										},
										{
											label: "Local media news story or advertising",
											value: "local-media"
										},
										{
											label: "Other (please specify below)",
											value: "other"
										},
									],

									additional_questions: [
										{
											label: "If other, please provide details",
											name: "22-question-1",
											type: "text",
											number: "1",
											placeholder: "Enter details",
										},
									]
								},
								{
									label: "Do you have any comments on the consultation materials provided?",
									number: "23",
									name: "23-question",
									type: "text",
								},
								{
									label: "Do you have any comments on your experience of the consultation overall, such as what you found helpful or things we could have done differently?",
									number: "24",
									name: "24-question",
									type: "text",
								}
							]
						},
					]
				}
			],
		},
	],

	// Home page elements
	maps: [
		{
			title: "The main reservoir site",
			image: "/assets/images/reservoir-image-home.jpg",
			description: "The proposed reservoir site, south-east of Sleaford, about halfway between Grantham and Boston. We've now developed an emerging design with ideas for the features it might include, and have also provisionally identified areas of land to the north and south of the reservoir site that we could need for environmental mitigation measures and/or construction.",
			url: "/proposals/our-latest-proposals/the-reservoir/our-emerging-design/"
		},
		{
			title: "Associated water infrastructure",
			image: "/assets/images/ai-image.jpg",
			description: "When there is available water in rivers that would otherwise drain to the sea, we would draw that water and transfer it to the reservoir using new and existing infrastructure and waterways. We've carried out multiple stages of assessment to identify areas of land within which the new infrastructure could be located to transfer water to the reservoir, treat it and then supply it to homes and businesses. The proposed locations are between Torksey, West Lindsey, Boston and south-west of Peterborough.",
			url: "/proposals/our-latest-proposals/associated-infrastructure/overview/"
		}
	],

	shortcuts: [
		{
			title: "Latest news",
			image: "/assets/images/latest-news.jpg",
			url: "/stay-informed/latest-news/"
		},
		{
			title: "Register for updates",
			image: "/assets/images/register.jpg",
			url: "/stay-informed/register/"
		},
		{
			title: "Get in touch",
			image: "/assets/images/contact-us.jpg",
			url: "/stay-informed/contact/"
		},
		{
			title: "Frequently asked questions",
			image: "/assets/images/faq-cta.jpg",
			url: "/faqs/"
		}
	],
};
